// export const BaseUrl = "http://localhost:50/mebel";
export const BaseUrl = "https://optomsavdo.uz/api";
export const narxlar = {
    val: false,
    som: true,
    perech: true,
};
